import moment from 'moment';

export const dateFormatHandler = (date, format) => {

    if (!date || date == null){
        return;
    }
  
    const dateObj = moment.utc(date);
    return dateObj.format(`${format && format != "null" ? format.toUpperCase() : "YYYY-MM-DD"}`);
  }

